<mat-checkbox
  labelPosition="before"
  [checked]="(analyticFilterService.filter$ | async).onlyWithComment"
  [disabled]="api.loading"
  (change)="onChangeFilterValue({ onlyWithComment: $event.checked })"
>With a review</mat-checkbox>
